import AbstractProvider from '../services/App/AbstractProvider';
import {resetWorkday, setWorkdayDetails} from '@src/_redux/workday';
import {IReduxWorkdayBreak, IReduxWorkdayState} from '@src/@interfaces';
import {ITimeCounterBreakModel} from '@src/@interfaces/models/TimeCounter/ITimeCounterBreakModel';
import {notNull} from '@src/helpers/ts/notNull';

export class UserWorkdayProvider extends AbstractProvider {
    async boot(): Promise<void> {
        this.app.make('auth').onUserDetailsChanged((event, {user}) => {
            this.app.dispatchAction(resetWorkday());

            if (!user) {
                return;
            }

            const counter = user.active_workday_time_counters?.at(-1);
            if (!counter) {
                return;
            }

            const workdayDetails: Partial<IReduxWorkdayState> = {
                started_at: counter.started_at,
                breaks: counter.breaks?.map(this.getBreakMeta).filter(notNull) ?? [],
                currentBreak: this.getBreakMeta(
                    counter.breaks?.filter(item => item.finished_at == null)?.at(-1)
                ),
            };

            this.app.dispatchAction(setWorkdayDetails(workdayDetails));
        });
    }

    protected getBreakMeta(item?: ITimeCounterBreakModel): IReduxWorkdayBreak | null {
        if (!item) {
            return null;
        }

        return {
            type: item.type as any,
            started_at: item.started_at ?? null,
            finished_at: item.finished_at ?? null,
        };
    }
}
